import apiClient from './axiosClient';

export const authorizationApi = {
    search: async (params) => {

       // alert("PARAMS : "+JSON.stringify(params))
        const res = await apiClient.get(`/api/referral/advanced?memberId=${params.memberId}&authNumber=${params.authNumber}&groupId=${params.group}&requestFrom=${params.from}&requestTo=${params.to}&referredToProvider=${params.taxId}&pageNo=${1}&pageLimit=${1000}`);
        const data = res?.data;

        //alert("RESULT DATA : "+JSON.stringify(data));

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
   // apiClient.get('/authorizations', { params }),
  // params: { memberId, authNumber, from, to }

  submit: (data) =>
    apiClient.post('/authorizations', data),

  getDetail: (id) =>
    apiClient.get(`/authorizations/${id}`),
};
